import ScheduleCard from './ScheduleCard.jsx';

function ScheduleCardTeacher({ scheduleData }) {
  return (
    <ScheduleCard
      scheduleData={scheduleData}
      itemKey='teacher'
      itemTitle={(item) => `Преподаватель: ${item.teacher}`}
      renderPairMeta={(pair) => (
        <>
          <p className='teacher'>
            Группа: {Array.isArray(pair.group_names) ? pair.group_names.join(', ') : pair.group_name}
          </p>
          <div className='pair-meta'>
            <span className='pair-type'>{pair.pair_type}</span>
            <span className='classroom'>Аудитория: {pair.class_room}</span>
          </div>
        </>
      )}
    />
  );
}

export default ScheduleCardTeacher;